import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Textarea from 'components/Textarea'
import useFormField from './useFormField'

const Input = ({
  label,
  helpText,
  className,
  controlClassName,
  labelClassName,
  fieldClassName,
  helpTextClassName,
  hideErrors,
  ...props
}) => {
  const {
    id,
    hasError,
    isDisabled,
    field,
    meta: {error},
  } = useFormField(props)

  const hasErrorToShow = !hideErrors && hasError

  const labelField = label ? (
    <label htmlFor={id} className={classNames('label', labelClassName)}>
      {label}
    </label>
  ) : null

  const inputProps = {
    ...field,
    ...props,
    id,
    disabled: isDisabled,
    className: classNames('input', className, {'is-danger': hasErrorToShow}),
  }

  return (
    <div className={classNames('field', fieldClassName)}>
      {labelField}
      <div className={classNames('control', controlClassName)}>
        {props.type !== 'textarea' ? (
          <input {...inputProps} />
        ) : (
          <Textarea {...inputProps} />
        )}
      </div>
      {hasErrorToShow ? <p className="help is-danger">{error}</p> : null}
      {helpText && (
        <p className={classNames('help', helpTextClassName)}>{helpText}</p>
      )}
    </div>
  )
}

Input.defaultProps = {
  hideErrors: false,
}

Input.propTypes = {
  className: PropTypes.string,
  controlClassName: PropTypes.string,
  fieldClassName: PropTypes.string,
  helpText: PropTypes.node,
  helpTextClassName: PropTypes.string,
  hideErrors: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.node,
  labelClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
}

export default Input
